import React from 'react'
import PropTypes from 'prop-types'

import { Splide, SplideTrack, SplideSlide } from '@splidejs/react-splide'

import styles from './styles.module.css'

const CommonSlider = ({ items, sliderOptions, slideStyles, className }) => {
  const options = {
    type: 'slide',
    pagination: false,
    arrows: false,
    direction: 'rtl',
    ...sliderOptions,
  }

  return (
    <Splide options={options} hasTrack={false} className={className}>
      <SplideTrack>
        {items.map((item) => (
          <SplideSlide style={slideStyles}>{item}</SplideSlide>
        ))}
      </SplideTrack>
    </Splide>
  )
}

CommonSlider.propTypes = {
  items: PropTypes.array,
  sliderOptions: PropTypes.object,
  slideStyles: PropTypes.object,
  className: PropTypes.string,
}

CommonSlider.defaultProps = {
  items: [],
  sliderOptions: {},
  slideStyles: {},
}

export default CommonSlider
